import { render, staticRenderFns } from "./TPIPPerformanceReview.vue?vue&type=template&id=16598c8e&scoped=true"
import script from "./TPIPPerformanceReview.vue?vue&type=script&lang=js"
export * from "./TPIPPerformanceReview.vue?vue&type=script&lang=js"
import style0 from "./TPIPPerformanceReview.vue?vue&type=style&index=0&id=16598c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16598c8e",
  null
  
)

export default component.exports